import * as types from './actionTypes'
import { payrollDefaultWorkHourService } from '../_services'

export function fetchPayrollDefaultWorkHours(data) {
    return dispatch => {
        return payrollDefaultWorkHourService
            .getPayrollDefaultWorkHours(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_EMP_DEFAULT_WORKHOUR, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_EMP_DEFAULT_WORKHOUR_FAILURE, error }
    }
}

// export function fetchEmployeeDefaultWorkHour(options) {
//     return dispatch => {
//         return payrollDefaultWorkHourService
//             .getPayrollDefaultWorkHours(options)
//             .then(payload => {
//                 dispatch(success(payload))
//             })
//             .catch(error => {
//                 dispatch(failure(error.toString()))
//             })
//     }

//     function success(payload) {
//         return { type: types.FETCH_EMP_DEFAULT_WORKHOUR, payload: payload }
//     }
//     function failure(error) {
//         return { type: types.FETCH_EMP_DEFAULT_WORKHOUR_FAILURE, error }
//     }
// }
